import topRateFunds from 'images/top-rated-fund.svg';
import NFOLogo from 'images/NFO-logo.svg';
import taxSaverFunds from 'images/tax-saver-funds.svg';
import equityFunds from 'images/equity-funds.svg';
import mintPacks from 'images/mintpacks-icon.svg';
import debitFunds from 'images/debt-funds.svg';
import liquidFunds from 'images/liquid-funds.svg';
import hybridFunds from 'images/hybrid-funds.svg';
import GrowYourEarnings from 'images/GrowYourEarnings.png';
import SellingMutualFunds from 'images/SellingMutualFunds.png';
import CreateLeadsFormututalfunds from 'images/CreateLeadsFormututalfunds.png';
import LAMFLogo from 'images/LAMF-logo.svg';

import { LearnBusinessType, PremiumServiceType } from '__utils/type';

import leadHeadphoneIcon from 'images/leadHeadphone.svg';
import leadStartIcon from 'images/leadStart.svg';
import leadCertificateIcon from 'images/certificate.svg';
import leadSpeakerIcon from 'images/leadSpeaker.svg';

import wealthIcon from 'images/wealth.svg';
import restIcon from 'images/rest.svg';
import childIcon from 'images/child.svg';
import carIcon from 'images/car.svg';

export const FAQs = [{
    title: 'What is Turtlemint Money?',
    content: 'Turtlemint Money is an AMFI registered (ARN – 159953) online platform for sale of mutual funds. Our certified investment experts provide you with end-to-end support to close mutual funds sales.'
}, {
    title: 'What are the benefits of using Turtlemint Money?',
    content: 'Turtlemint Money provides you a completely paperless means to invest into 2000+ mutual funds schemes. Your clients can start with an investment amount as low as INR 100 and pay through Netbanking, UPI, Cheque or NEFT. We also provide paperless KYC for first time investors. Additionally, our certified investment experts provide end-to-end sales, operations & training support to help you grow your mutual funds business.'
}, {
    title: 'What is the Turtlemint Money Assisted Sales Model?',
    content: 'Under Assisted Sales Model, you will be mapped to an Investment Expert, who is certified by Association of Mutual Funds in India (AMFI) to distribute mutual funds. He/She is your go-to person for any kind of sales, operations and training support. Every Mintpro Digital Partner who signs up for Assisted Sales Model gets a dedicated investment expert to help you grow your mutual funds business. <a href=/login>Click here</a> to sign up for Assisted Sales Model.'
}, {
    title: 'Which mutual fund schemes can I sell using Turtlemint Money?',
    content: 'Turtlemint Money supports all mutual fund schemes available in the market. There are 2000+ scheme in the market across 40 Asset Management Companies (AMCs). Any of these schemes can be sold through Turtlemint Money.'
}, 
//  {
//     title: 'How can my clients track performance of their investment portfolio?',
//     content: 'Once you process an investment for your customer through Mintpro, the customer can go to www.turtlemintmoney.com and login to his/her account to view and track entire portfolio. On the login page, customer needs to click on ‘Forgot Password’ to reset his/her account password.'
// }, 
{
    title: 'How can I get the Consolidated Account Statement(CAS) for my customer?',
    content: 'Click on the CAMS OR the KFintech(Karvy) RTA links given below. Once you are on the CAMS/KFintech website, you will have to enter your customer&#39;s registered email and PAN. You will have to enter a password and confirm it, which will be used for opening the CAS file. If you are going to share the file with the Mintpro team, please set the password as "123456". The statement will be sent to your customer&#39;s registered email address within a few hours. You will be prompted for the password you had entered earlier to view the file. <br> <a href="https://new.camsonline.com/Investors/Statements/Consolidated-Account-Statement"> Link for CAS statement from CAMS</a> <br>OR <br> <a href="https://mfs.kfintech.com/investor/General/ConsolidatedAccountStatement" target="_blank">Link for CAS statement from Karvy/KFintech</a>'
}, {
    title: 'Where can I find the Change of Broker form?',
    content: 'You can access the Change of Broker form for CAMS <a href="https://new.camsonline.com/Distributors/Service-Requests/Service-Request-Forms/Change-Broker">here</a>. <br>Our AMFI Registration Number is ARN - 159953.'
}, {
    title: 'How can my customer activate a Mandate for auto-payment of SIP?',
    content: 'You can view the process for setting up your customer&#39;s mandate by clicking <a href="https://youtu.be/_WVx6l7lcT0">here.</a>'
}
];

export const browseMutualFunds = [
    {
        "title": "Best Performing",
        "mobileTitle": "Best Performing",
        "icon": topRateFunds,
        "type": "Best Performing Funds",
        "description": "Mutual Fund schemes with best historical performance.",
        "redirectUrl": "best-performing-funds"
    }, {
        "title": "Tax Saver",
        "mobileTitle": "Tax Saver",
        "icon": taxSaverFunds,
        "type": "Tax Saver Funds",
        "description": "Funds that help you save upto Rs 46,800* in taxes under Section 80C.",
        "redirectUrl": "mutual-fund-results/Equity/ELSS (Tax Savings)?mutualFundCategory=Equity&subCategory=ELSS (Tax Savings)"
    }, {
        "title": "LOAN AGAINST MF",
        "mobileTitle": "Loan Against MF",
        "icon": LAMFLogo,
        "type": "Loan Against MF",
        "description": "Leverage your customers mutual funds for loans.",
        "externalRedirect" : true,
        "redirectUrl": `https://app.turtlefin.com/products/lamf`
    },{
        
        "title": "NFO",
        "mobileTitle": "NFO",
        "icon": NFOLogo,
        "type": "NFO",
        "description": "New funds offered by AMCs on a first-subscription basis.",
        "redirectUrl": 'v1/nfos'

    }, {
        "title": "Equity Funds",
        "mobileTitle": "Equity",
        "icon": equityFunds,
        "type": "Equity Funds",
        "description": "Mutual fund schemes for long term wealth creation prospects.",
        "redirectUrl": 'mutual-fund-results/Equity?mutualFundCategory=Equity'

    }, {
        "title": "Debt Funds",
        "mobileTitle": "Debt",
        "icon": debitFunds,
        "type": "Debt Funds",
        "description": "Mutual fund schemes that invest in fixed income instruments.",
        "redirectUrl": "mutual-fund-results/Fixed Income?mutualFundCategory=Fixed Income"
    }, {
        "title": "Liquid Funds",
        "mobileTitle": "Liquid",
        "icon": liquidFunds,
        "type": "Liquid Funds",
        "description": "Mutual funds with instant redemption facility.",
        "redirectUrl": "mutual-fund-results/Money Market/Liquid?mutualFundCategory=Money Market&subCategory=Liquid"

    }, {
        "title": "Balanced Funds",
        "mobileTitle": "Hybrid",
        "icon": hybridFunds,
        "type": "Hybrid Funds",
        "description": "Funds to diversify your investment in equity and debt funds.",
        "redirectUrl": "mutual-fund-results/Allocation/Less than 1 Year?mutualFundCategory=Allocation"
    }, 
    // {
    //     "title": "Mintpack",
    //     "mobileTitle": "Mintpack",
    //     "icon": mintPacks,
    //     "type": "Mintpack",
    //     "description": "",
    //     "redirectUrl": "mint-packs"

    // },
];

export const premiumServices: Array<PremiumServiceType> = [
    {
        serviceTitle: "Company Funds Investment Solution",
        icon: "company-funds-investment-solution.svg",
        type: "company-funds-investment",
        url: "premium-service-details/company-funds-investment"
    },
    {
        serviceTitle: "Post-Retirement Investment Solution",
        icon: "post-retirement-investment.svg",
        type: "retirement-income-planning",
        url: "premium-service-details/retirement-income-planning"
    },
    {
        serviceTitle: "Custom Portfolio Rebalance Solution",
        icon: "custom-portfolio-rebalance.svg",
        type: "custom-portfolio-review",
        url: "premium-service-details/custom-portfolio-review"
    }
]

export const learnBusinessList: Array<LearnBusinessType> = [
    {
        videoTitle: "Multiply your earnings by starting Mutual Funds Business",
        icon: GrowYourEarnings,
        videoSrc: "https://www.youtube.com/embed/DdOCQFrvjD8"
    },
    {
        videoTitle: "Get Started with Mutual Funds on Mintpro",
        icon: SellingMutualFunds,
        videoDesc: "Learn how to get started with doing Mutual Funds business on Mintpro.",
        videoSrc: "https://www.youtube.com/embed/SHsa_sWrOg8"
    },
    {
        videoTitle: "How to Create Leads for Mutual Funds on Mintpro app",
        icon: CreateLeadsFormututalfunds,
        videoDesc: "Learn how to create your first mutual funds lead & share it.",
        videoSrc: "https://www.youtube.com/embed/vKTZnVyCt4s"
    }
]

export const investmentGoalObj = [
    {
        name: 'Wealth',
        image: wealthIcon
    }, {
        name: 'Retirement',
        image: restIcon
    }, {
        name: 'Child',
        image: childIcon
    }, {
        name: 'Vehicle',
        image: carIcon
    }
]

export const homeLeadObj = [
    {
        desc1: 'Free expert advice for all your leads', 
        desc2: 'Select client’s goals', 
        image: leadHeadphoneIcon
    }, {
        desc1: 'Activity points on every sale', 
        desc2: 'Receive sales team call', 
        image: leadStartIcon
    }, {
        desc1: 'Professional training for NISM certification', 
        desc2: 'Collaborate on client portfolio', 
        image: leadCertificateIcon
    }, {
        desc1: 'Marketing support to grow your business', 
        desc2: 'Sale completed', 
        image: leadSpeakerIcon
    },
]